
import { useViewDataStore } from './defines/store/viewDataStore'
import { graphql, fetchQuery } from "react-relay";
import { RelayEnvironment } from "@/RelayEnvironment";
import { useEffect } from 'react';
import type { CommonProviderQuery$data as QueryDataType } from './__generated__/CommonProviderQuery.graphql'
import type { CommonProviderCityDicQuery$data as CityDistrictQueryDataType } from './__generated__/CommonProviderCityDicQuery.graphql'
import { useLoadingStore } from './defines/store/loadingStore';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';

const commonProviderQuery = graphql`
  query CommonProviderQuery {
    system_connection {
        edges {
            node {
                id
                key
                value
            }
        }
    }
  }
`;

const commonProviderCityDicQuery = graphql`
  query CommonProviderCityDicQuery {
    citydistrict_connection {
        edges {
        node {
            city
            district
            id
        }
        }
    }
  }
`;

export const CommonProvider = ({ children }: { children: React.ReactNode }) => {

    // console.log(useUserStore.getState().token);
    const loadingStore = useLoadingStore();

    useEffect(() => {
        const lastViewUpdate = useViewDataStore.getState().lastViewUpdate;
        if ((new Date().getTime() - new Date(lastViewUpdate).getTime()) > 60 * 1000) {

            fetchQuery(RelayEnvironment, commonProviderQuery, {})
                .subscribe({
                    next: (response) => {
                        let data = response as QueryDataType;
                        data.system_connection.edges.forEach((edge) => {
                            // console.log('edge', edge.node.key, edge.node.value);
                            if (edge.node.key === 'activeUsers') {
                                useViewDataStore.setState({ activeUsers: edge.node.value ?? '' });
                            }
                            else if (edge.node.key === 'screenPageViews') {
                                useViewDataStore.setState({ screenPageViews: edge.node.value ?? '' });
                            }
                        });
                        useViewDataStore.setState({ lastViewUpdate: new Date() });
                    },
                    error: (err: any) => {
                        console.log('err');
                        console.log(err);
                    },
                });
        }


        const lastCityDistrictUpdate = useViewDataStore.getState().lastCityDistrictUpdate;
        // if (true) {
        if (((new Date().getTime() - new Date(lastCityDistrictUpdate).getTime()) / 1000) > 60 * 60 * 24) {

            fetchQuery(RelayEnvironment, commonProviderCityDicQuery, {})
                .subscribe({
                    next: (response) => {

                        let data = response as CityDistrictQueryDataType;
                        useViewDataStore.setState({ cityDistricts: [] });
                        let forAdd: { city: string, district: string[] }[] = [];
                        data.citydistrict_connection.edges.forEach((edge) => {
                            let forAddDistrict: string[] = [];
                            edge.node.district.forEach((district) => {
                                forAddDistrict.push(district);
                            });
                            forAdd.push({ city: edge.node.city, district: forAddDistrict });
                        });
                        useViewDataStore.setState({ cityDistricts: forAdd });
                        useViewDataStore.setState({ lastCityDistrictUpdate: new Date() });
                    },
                    error: (err: any) => {
                        console.log('err');
                        console.log(err);
                    },
                });
        }
    }, []);

    useEffect(() => {
        console.log('loadingStore update', loadingStore);
    }, [loadingStore.show])

    return (
        <>
            {
                loadingStore.show ?

                    <Dialog open={true} onClose={() => { }} className="relative z-50">
                        <DialogBackdrop
                            transition
                            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 
                            data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                        />
                        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                                <DialogPanel
                                    transition
                                    className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 
                                    text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 
                                    data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in 
                                    sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                                >
                                    <div>
                                        <div className="mt-3 text-center sm:mt-5">
                                            <div className="mt-2">
                                                <div className="flex items-center justify-center w-full h-full">
                                                    <span className="w-32 h-32 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></span>
                                                </div>
                                            </div>
                                            <DialogTitle as="h3" className="text-2xl mt-5 font-semibold text-gray-900">
                                                {loadingStore.message}
                                            </DialogTitle>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </div>
                        </div>
                    </Dialog>

                    // <div className="bg-white z-10 h-screen w-screen flex justify-center">
                    // <div className="absolute bg-white bg-opacity-80 z-10 h-full w-full flex justify-center">
                    //     <div className="flex items-center">
                    //         <span className="text-3xl mr-4">{loadingStore.message}</span>
                    //     </div>
                    //     <div className="flex items-center">
                    //         <svg className="animate-spin h-8 w-8 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                    //             viewBox="0 0 24 24">
                    //             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    //             <path className="opacity-75" fill="currentColor"
                    //                 d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    //             </path>
                    //         </svg>
                    //     </div>
                    // </div>
                    // </div>
                    : <></>
            }

            {children}
        </>
    );
};